import { CSSProperties, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { CalendarEvent } from '../../types';
import { timeToRowNumber } from '../../utils';

interface Props extends Pick<CalendarEvent, 'id' | 'startTime' | 'duration'> {
  style: CSSProperties;
}

export const EventShell = ({ children, id, startTime, duration, style }: PropsWithChildren<Props>) => {
  const combinedStyle = {
    '--start-row': timeToRowNumber(startTime),
    '--duration-in-minutes': duration,
    ...style,
  } as CSSProperties;

  return (
    <article data-event-id={id} css={containerStyle} style={combinedStyle}>
      {children}
    </article>
  );
};

const containerStyle = css({
  gridRow: 'var(--start-row) / span var(--duration-in-minutes)',
  gridColumn: 1,
  overflow: 'visible',
  willChange: 'transform',
  '> *': {
    height: '100%',
  },
});
